import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetScheduleScenariosQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetScheduleScenariosQuery = { __typename?: 'query_root', scenarios: Array<{ __typename?: 'scenarios', id: number, status: string, scenario_key: string, moves: Array<{ __typename?: 'scenariotomoves', id: number, cardinality: number, move: { __typename?: 'moves', id: number, active: number, cancel_reason?: string | null, cancel_requested_at?: string | null, cancel_status?: string | null, canceled_at?: string | null, chargeable: boolean, config?: object | null, consumer_at_pickup: number, consumer_name?: string | null, consumer_phone?: string | null, consumer_pickup?: boolean | null, consumer_type?: string | null, createdat?: string | null, createdBy?: string | null, customer_id?: number | null, deliver_by?: string | null, delivery_arrived?: string | null, delivery_started?: string | null, delivery_successful?: string | null, delivery_time?: string | null, driver_id?: number | null, driver_name?: string | null, lane_id?: number | null, lite: boolean, manual_flag: boolean, move_type: string, ride_type?: string | null, parent_move_id?: number | null, payer_id?: number | null, pickup_arrived?: string | null, pickup_started?: string | null, pickup_successful?: string | null, pickup_time?: string | null, ready_by?: string | null, reference_num?: string | null, status?: string | null, tags?: string | null, updatedat?: string | null, usecase_key?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, customer?: { __typename?: 'customers', id: number, name?: string | null } | null, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null } | null } | null, eventlogs: Array<{ __typename?: 'eventlogs', id: number, user: string }>, hangtags: Array<{ __typename?: 'hangtags', id: number, hash_id: string, rear_code?: string | null, status: string, type: string, updated_at?: string | null, workflow_data?: object | null }>, lane?: { __typename?: 'lanes', id: number, description?: string | null, distance_miles?: number | null, duration_sec?: number | null, pickup_inspection_sec?: number | null, delivery_inspection_sec?: number | null, return_ride_wait_sec?: number | null, inverse?: { __typename?: 'lanes', id: number, duration_sec?: number | null } | null, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null }, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null } } | null, movesByReturnRideId: Array<{ __typename?: 'moves', id: number, consumer_at_pickup: number, consumer_name?: string | null, consumer_phone?: string | null, consumer_pickup?: boolean | null, consumer_type?: string | null }>, parentMove?: { __typename?: 'moves', id: number, lite: boolean, status?: string | null, cancel_status?: string | null } | null, workflowset?: { __typename?: 'workflowsets', id: number, name: string } | null } }>, bundletoscenarios: Array<{ __typename?: 'bundletoscenarios', bundle: { __typename?: 'bundles', id: number, offers: Array<{ __typename?: 'offers', id: number, status: string, driver: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', display_name: string, avatar_url?: string | null } | null } }> } }> }> };


export const GetScheduleScenariosDocument = gql`
    query getScheduleScenarios($start: timestamptz!, $end: timestamptz!, $customerId: bigint!) {
  scenarios(
    where: {status: {_neq: "deprecated"}, moves: {move: {active: {_eq: 1}, cancel_status: {_is_null: true}, _or: [{parent_move_id: {_is_null: true}}, {parentMove: {cancel_status: {_is_null: true}}}], _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}, {pickup_started: {_gte: $start, _lte: $end}}, {pickup_arrived: {_gte: $start, _lte: $end}}, {pickup_successful: {_gte: $start, _lte: $end}}, {delivery_started: {_gte: $start, _lte: $end}}, {delivery_arrived: {_gte: $start, _lte: $end}}, {delivery_successful: {_gte: $start, _lte: $end}}]}]}}}
    order_by: {id: desc}
  ) {
    id
    status
    scenario_key
    moves(
      where: {move: {active: {_eq: 1}, cancel_status: {_is_null: true}, _or: [{parent_move_id: {_is_null: true}}, {parentMove: {cancel_status: {_is_null: true}}}]}}
      order_by: {cardinality: asc}
    ) {
      id
      cardinality
      move {
        id
        active
        cancel_reason
        cancel_requested_at
        cancel_status
        canceled_at
        chargeable
        config
        consumer_at_pickup
        consumer_name
        consumer_phone
        consumer_pickup
        consumer_type
        createdat
        createdBy
        customer_id
        deliver_by
        delivery_arrived
        delivery_started
        delivery_successful
        delivery_time
        driver_id
        driver_name
        lane_id
        lite
        manual_flag
        move_type
        ride_type
        parent_move_id
        payer_id
        pickup_arrived
        pickup_started
        pickup_successful
        pickup_time
        ready_by
        reference_num
        status
        tags
        updatedat
        usecase_key
        vehicle_color
        vehicle_make
        vehicle_model
        vehicle_stock
        vehicle_vin
        vehicle_year
        customer {
          id
          name
        }
        driver {
          id
          user {
            id
            display_name
            avatar_url
          }
        }
        eventlogs(where: {actiontype_id: {_eq: 1}}) {
          id
          user
        }
        hangtags(order_by: {updated_at: desc}) {
          id
          hash_id
          rear_code
          status
          type
          updated_at
          workflow_data
        }
        lane {
          id
          description
          distance_miles
          duration_sec
          pickup_inspection_sec
          delivery_inspection_sec
          return_ride_wait_sec
          inverse {
            id
            duration_sec
          }
          pickup {
            id
            name
            address
            latitude
            longitude
          }
          delivery {
            id
            name
            address
            latitude
            longitude
          }
        }
        movesByReturnRideId {
          id
          consumer_at_pickup
          consumer_name
          consumer_phone
          consumer_pickup
          consumer_type
        }
        parentMove {
          id
          lite
          status
          cancel_status
        }
        workflowset {
          id
          name
        }
      }
    }
    bundletoscenarios(order_by: {id: desc}) {
      bundle {
        id
        offers(
          where: {status: {_in: ["offered", "accepted", "assigned"]}}
          order_by: {id: desc}
        ) {
          id
          status
          driver {
            id
            user {
              display_name
              avatar_url
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetScheduleScenariosQuery__
 *
 * To run a query within a React component, call `useGetScheduleScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleScenariosQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetScheduleScenariosQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleScenariosQuery, GetScheduleScenariosQueryVariables> & ({ variables: GetScheduleScenariosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleScenariosQuery, GetScheduleScenariosQueryVariables>(GetScheduleScenariosDocument, options);
      }
export function useGetScheduleScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleScenariosQuery, GetScheduleScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleScenariosQuery, GetScheduleScenariosQueryVariables>(GetScheduleScenariosDocument, options);
        }
// @ts-ignore
export function useGetScheduleScenariosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScheduleScenariosQuery, GetScheduleScenariosQueryVariables>): Apollo.UseSuspenseQueryResult<GetScheduleScenariosQuery, GetScheduleScenariosQueryVariables>;
export function useGetScheduleScenariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScheduleScenariosQuery, GetScheduleScenariosQueryVariables>): Apollo.UseSuspenseQueryResult<GetScheduleScenariosQuery | undefined, GetScheduleScenariosQueryVariables>;
export function useGetScheduleScenariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScheduleScenariosQuery, GetScheduleScenariosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScheduleScenariosQuery, GetScheduleScenariosQueryVariables>(GetScheduleScenariosDocument, options);
        }
export type GetScheduleScenariosQueryHookResult = ReturnType<typeof useGetScheduleScenariosQuery>;
export type GetScheduleScenariosLazyQueryHookResult = ReturnType<typeof useGetScheduleScenariosLazyQuery>;
export type GetScheduleScenariosSuspenseQueryHookResult = ReturnType<typeof useGetScheduleScenariosSuspenseQuery>;
export type GetScheduleScenariosQueryResult = Apollo.QueryResult<GetScheduleScenariosQuery, GetScheduleScenariosQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/schedule/queries/getScheduleScenarios.query.gql}
 */
export async function getScheduleScenarios(
  variables: GetScheduleScenariosQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetScheduleScenariosQuery['scenarios']>
export async function getScheduleScenarios(
  variables: GetScheduleScenariosQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetScheduleScenariosQuery>
export async function getScheduleScenarios(
  variables: GetScheduleScenariosQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetScheduleScenariosQuery['scenarios'] | GetScheduleScenariosQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetScheduleScenariosQuery>(
    GetScheduleScenariosDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.scenarios
}